import localStorageHelper from './localStorageHelper';
import logger from 'helpers/logger';

function getClarityID() {
    try {
        return localStorageHelper.nonEncrypted.getItem('environmentProperties')?.clarityID;
    }
    catch {
        logger.error('Clarity Id retrieval error.');
        return '';
    }

}
export const clarity = () => {
    return (function (c, l, a, r, i) {
        if (!i) { return; }
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        const t = l.createElement(r);
        t.async = 1;
        t.src = 'https://www.clarity.ms/tag/' + i;
        const y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', getClarityID());
};
